import { render } from "./FinalePopup.vue?vue&type=template&id=e73edffe&ts=true"
import script from "./FinalePopup.vue?vue&type=script&lang=ts"
export * from "./FinalePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__